import React from "react";
import "swiper/css";
import MapView from "../../components/common/Map/MapView";
import Heading from "../../components/common/Typography/Heading";
import {
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const ServicesMapView = () => {
  return (
    <>
      <div className={`tp-container-main mx-auto ${PUBLIC_SECTION_GAP_CLASS}`}>
        <div className="flex items-center justify-between">
          <Heading
            variant={"h2"}
            className={"flex justify-start text-start text-offblack"}
          >
            Services near you
          </Heading>
        </div>
      </div>
      <div className="tp-container-fluid mx-auto">
      {/* <div className="mx-[5%] xl:mx-[2%] 2xl:mx-auto 2xl:w-[1748px] h-[500px] md:h-[700px] lg:h-[700px] xl:h-[800px] 2xl:h-[1100px] mt-7 sm:mt-10"> */}
        <div className={`2xl:mx-auto flex justify-center h-[600px] xs:h-[650px] lg:h-[700px] xl:h-[800px] 2xl:h-[1000px] ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
        <MapView />
      </div>
      </div>
    </>
  );
};

export default ServicesMapView;
